import React from "react";
import { formatCurrency, formatRechargedAmount, formatSimpleDate, totalTopUpAmountValue } from "../../utils";

const AdTracker = ({
  ppcSubscriptionDetail,
  onPauseClick,
  onCancelClick,
  isLoading,
}) => {
  if (!ppcSubscriptionDetail || (ppcSubscriptionDetail && !ppcSubscriptionDetail.isPPCActive)) {
    return null;
  }

  // Destructure properties from the local state.
  const {
    isPaused,
    isCancelled,
    ppcAllocatedBudget = 0, 
    ppcAmountDeposited = 0,
    adSpendForThisMonth = 0,
    ppcRemainingBudget = 0,
    currentPeriodStart,
    currentPeriodEnd,
    currentCycleClicks = 0,
    topUpBudget=0,
    topUpRemaining=0,
    topUpClicks=0,
    totalTopUpBudget=[],
  } = ppcSubscriptionDetail;



  const handlePauseClick = () => {
    onPauseClick(); // This should handle both pausing and resuming based on the current state.
  };

  const handleCancelClick = () => {
    onCancelClick();
  };

    // Call the utility function to format the recharged amount
    const rechargedAmountDisplay = formatRechargedAmount(totalTopUpBudget);
    const totalTopUpAmount = totalTopUpAmountValue(totalTopUpBudget);
  

    



  

  return (
    <div className="d-none d-sm-block">
    <div className="ad-tracker-card">
      <h3 className="ad-tracker-title">Ad Tracker</h3>

      <div className="ad-tracker-content">
        <div className="tracker-row">
          <div className="tracker-label">Effective Start Date</div>
          <div className="tracker-separator">:</div>
          <div className="tracker-value">
            {formatSimpleDate(currentPeriodStart)}
          </div>
        </div>


        <hr/>

        <div className="tracker-row">
          <div className="tracker-label">Allocated Budget</div>
          <div className="tracker-separator">:</div>
          <div className="tracker-value">{formatCurrency(ppcAllocatedBudget)}</div>
        </div>

        <div className="tracker-row">
          <div className="tracker-label">Amount Deposited (30%)</div>
          <div className="tracker-separator">:</div>
          <div className="tracker-value">{formatCurrency(ppcAmountDeposited)}</div>
        </div>

        <div className="tracker-row">
          <div className="tracker-label">Ad Spend for This Month</div>
          <div className="tracker-separator">:</div>
          <div className="tracker-value">{formatCurrency(adSpendForThisMonth)}</div>
        </div>

        <div className="tracker-row">
          <div className="tracker-label">Remaining Deposit</div>
          <div className="tracker-separator">:</div>
          <div className="tracker-value">{formatCurrency(ppcRemainingBudget)}</div>
        </div>

        <div className="tracker-row">
          <div className="tracker-label">No.of Clicks (this month)</div>
          <div className="tracker-separator">:</div>
          <div className="tracker-value">{currentCycleClicks}</div>
        </div>

        <hr />

        <div className="tracker-row">
            <div className="tracker-label">Recharged Amount (this Month)</div>
            <div className="tracker-separator">:</div>
            <div className="tracker-value">
            {rechargedAmountDisplay}
            </div>
          </div>

        <div className="tracker-row">
            <div className="tracker-label">Clicks via Recharge</div>
            <div className="tracker-separator">:</div>
            <div className="tracker-value ">
              {topUpClicks}
            </div>
          </div>

          <div className="tracker-row">
            <div className="tracker-label">Spend via Recharge</div>
            <div className="tracker-separator">:</div>
            <div className="tracker-value">
              {formatCurrency(totalTopUpAmount - topUpRemaining)}
            </div>
          </div>

          <div className="tracker-row">
            <div className="tracker-label">Remaining Recharge Balance</div>
            <div className="tracker-separator">:</div>
            <div className="tracker-value">
              {formatCurrency(topUpRemaining)}
            </div>
          </div>

          <hr/>


          <div className="tracker-row">
          <div className="tracker-label">Cycle End Date</div>
          <div className="tracker-separator">:</div>
          <div className="tracker-value">
            {formatSimpleDate(currentPeriodEnd)}
          </div>
        </div>
        

       

   
      </div>

      <div className="ad-tracker-actions">
        <button
          className={`btn-cancel ${isCancelled ? "disabled" : ""}`}
          onClick={handleCancelClick}
          disabled={isCancelled || isLoading}
        >
          {isCancelled ? "Cancelled" : "Cancel"}
        </button>
        <button
          className={`btn-pause ${isCancelled ? "disabled" : ""}`}
          onClick={handlePauseClick}
          disabled={isLoading || isCancelled}
        >
          {isPaused ? "Resume" : "Pause"} {/* Toggle between Resume and Pause */}
        </button>
      </div>
    </div>
    </div>
  );
};

export default AdTracker;
